// extracted by mini-css-extract-plugin
export default {"ptxt":"style_ptxt__Zpw8O","h2ChangeHead":"style_h2ChangeHead__rfo7e","pInfo":"style_pInfo__A5nAo","socials":"style_socials__nV7PB"};